/**
 * bookingsrv API
 * bookingsrv API documentation
 *
 * OpenAPI spec version: 0.0.1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional } from '@angular/core';
import {
  HttpClient,
  HttpHeaders,
  HttpParams,
  HttpResponse,
  HttpEvent
} from '@angular/common/http';
import { CustomHttpUrlEncodingCodec } from '../encoder';
import { Observable } from 'rxjs';

import { BookingDTO } from '../model/bookingDTO';
import { BookingPartnerRequestDTO } from '../model/bookingPartnerRequestDTO';
import { PartnerMyBookingSearchRequest } from '../model/partnerMyBookingSearchRequest';
import { PartnerMyBookingSearchResponse } from '../model/partnerMyBookingSearchResponse';

import { BASE_PATH, COLLECTION_FORMATS } from '../variables';
import { Configuration } from '../configuration';

@Injectable()
export class PartnerBookingResourceService {
  protected basePath = 'https://api.gotadi.com';
  public defaultHeaders = new HttpHeaders();
  public configuration = new Configuration();

  constructor(
    protected httpClient: HttpClient,
    @Optional() @Inject(BASE_PATH) basePath: string,
    @Optional() configuration: Configuration
  ) {
    if (basePath) {
      this.basePath = basePath;
    }
    if (configuration) {
      this.configuration = configuration;
      this.basePath = basePath || configuration.basePath || this.basePath;
    }
  }

  /**
   * @param consumes string[] mime-types
   * @return true: consumes contains 'multipart/form-data', false: otherwise
   */
  private canConsumeForm(consumes: string[]): boolean {
    const form = 'multipart/form-data';
    for (const consume of consumes) {
      if (form === consume) {
        return true;
      }
    }
    return false;
  }

  /**
   * getBookingByNumber
   *
   * @param bookingNumber bookingNumber
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getBookingByNumberUsingGET(
    bookingNumber: string,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<BookingDTO>;
  public getBookingByNumberUsingGET(
    bookingNumber: string,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<BookingDTO>>;
  public getBookingByNumberUsingGET(
    bookingNumber: string,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<BookingDTO>>;
  public getBookingByNumberUsingGET(
    bookingNumber: string,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    if (bookingNumber === null || bookingNumber === undefined) {
      throw new Error(
        'Required parameter bookingNumber was null or undefined when calling getBookingByNumberUsingGET.'
      );
    }

    let queryParameters = new HttpParams({
      encoder: new CustomHttpUrlEncodingCodec()
    });
    queryParameters = queryParameters.set('bookingNumber', <any>bookingNumber);

    let headers = this.defaultHeaders;
    const httpHeaderAccepts: string[] = ['*/*'];
    const httpHeaderAcceptSelected:
      | string
      | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    const consumes: string[] = ['application/json'];

    return this.httpClient.get<BookingDTO>(
      `${this.basePath}/api/partner/get-booking-by-number`,
      {
        params: queryParameters,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * getBookingByOrderId
   *
   * @param orderId orderId
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getBookingByOrderIdUsingGET(
    orderId: string,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<BookingDTO>;
  public getBookingByOrderIdUsingGET(
    orderId: string,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<BookingDTO>>;
  public getBookingByOrderIdUsingGET(
    orderId: string,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<BookingDTO>>;
  public getBookingByOrderIdUsingGET(
    orderId: string,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    if (orderId === null || orderId === undefined) {
      throw new Error(
        'Required parameter orderId was null or undefined when calling getBookingByOrderIdUsingGET.'
      );
    }

    let queryParameters = new HttpParams({
      encoder: new CustomHttpUrlEncodingCodec()
    });
    queryParameters = queryParameters.set('orderId', <any>orderId);

    let headers = this.defaultHeaders;
    const httpHeaderAccepts: string[] = ['*/*'];
    const httpHeaderAcceptSelected:
      | string
      | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    const consumes: string[] = ['application/json'];

    return this.httpClient.get<BookingDTO>(
      `${this.basePath}/api/partner/get-booking-by-order-id`,
      {
        params: queryParameters,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * savePartnerRequest
   *
   * @param bookingPartnerReqDTO bookingPartnerReqDTO
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public savePartnerRequestUsingPUT(
    bookingPartnerReqDTO: BookingPartnerRequestDTO,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<BookingDTO>;
  public savePartnerRequestUsingPUT(
    bookingPartnerReqDTO: BookingPartnerRequestDTO,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<BookingDTO>>;
  public savePartnerRequestUsingPUT(
    bookingPartnerReqDTO: BookingPartnerRequestDTO,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<BookingDTO>>;
  public savePartnerRequestUsingPUT(
    bookingPartnerReqDTO: BookingPartnerRequestDTO,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    if (bookingPartnerReqDTO === null || bookingPartnerReqDTO === undefined) {
      throw new Error(
        'Required parameter bookingPartnerReqDTO was null or undefined when calling savePartnerRequestUsingPUT.'
      );
    }

    let headers = this.defaultHeaders;
    const httpHeaderAccepts: string[] = ['*/*'];
    const httpHeaderAcceptSelected:
      | string
      | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    const consumes: string[] = ['application/json'];
    const httpContentTypeSelected:
      | string
      | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    return this.httpClient.put<BookingDTO>(
      `${this.basePath}/api/partner/update-booking`,
      bookingPartnerReqDTO,
      {
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * searchMyBookings
   *
   * @param req req
   * @param requesterInfoProperties
   * @param requesterInfoOrgCode
   * @param requesterInfoAgencyCode
   * @param requesterInfoCooperationClass
   * @param requesterInfoExtendInfo
   * @param requesterInfoAgencyId
   * @param requesterInfoBranchCode
   * @param requesterInfoRequesterType
   * @param requesterInfoRequesterCode
   * @param requesterInfoRequesterName
   * @param requesterInfoProfileId
   * @param requesterInfoMembershipClass
   * @param requesterInfoExpirationInMilis
   * @param requesterInfoLang
   * @param password
   * @param username
   * @param accountNonExpired
   * @param accountNonLocked
   * @param credentialsNonExpired
   * @param enabled
   * @param page Page number of the requested page
   * @param size Size of a page
   * @param sort Sorting criteria in the format: property(,asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public searchMyBookingsUsingPOST(
    req: PartnerMyBookingSearchRequest,
    page?: number,
    size?: number,
    sort?: Array<string>,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<PartnerMyBookingSearchResponse>;
  public searchMyBookingsUsingPOST(
    req: PartnerMyBookingSearchRequest,
    page?: number,
    size?: number,
    sort?: Array<string>,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<PartnerMyBookingSearchResponse>>;
  public searchMyBookingsUsingPOST(
    req: PartnerMyBookingSearchRequest,
    page?: number,
    size?: number,
    sort?: Array<string>,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<PartnerMyBookingSearchResponse>>;
  public searchMyBookingsUsingPOST(
    req: PartnerMyBookingSearchRequest,
    page?: number,
    size?: number,
    sort?: Array<string>,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    if (req === null || req === undefined) {
      throw new Error(
        'Required parameter req was null or undefined when calling searchMyBookingsUsingPOST.'
      );
    }

    let queryParameters = new HttpParams({
      encoder: new CustomHttpUrlEncodingCodec()
    });

    if (page !== undefined && page !== null) {
      queryParameters = queryParameters.set('page', <any>page);
    }
    if (size !== undefined && size !== null) {
      queryParameters = queryParameters.set('size', <any>size);
    }
    if (sort) {
      sort.forEach(element => {
        queryParameters = queryParameters.set('sort', <any>element);
      });
    }

    let headers = this.defaultHeaders;
    const httpHeaderAccepts: string[] = ['*/*'];
    const httpHeaderAcceptSelected:
      | string
      | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    const consumes: string[] = ['application/json'];
    const httpContentTypeSelected:
      | string
      | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    return this.httpClient.post<PartnerMyBookingSearchResponse>(
      `${this.basePath}/api/partner/my-booking`,
      req,
      {
        params: queryParameters,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }
}
